import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { ILeaveTypeSlice } from "./types";

const selectSelf = (state: RootState) => state;
const selectLeaveType = createSelector(selectSelf, (state) => state.leaveType);

export const selectLeaveTypeList = createSelector(
  selectLeaveType,
  (slice: ILeaveTypeSlice) => slice.leaveTypeList
);

export const selectIsLeaveTypeLoading = createSelector(
  selectLeaveType,
  (slice: ILeaveTypeSlice) => slice.isLoading
);
